import { standardAccountNumberFormat } from "../../../../../utils/standardAccountNumberFormat";
import IfscCodeMapper from "../../../IfscLogoMapper";
import SVGComponent from "../../../SVGComponent";
/**
 * @param {Object} props
 * @param {String} props.sourceAccNo - source account number
 * @param {String} props.sourceIfsc - source ifsc code
 * @param {String} props.destinationAccNo - destination account number
 * @param {String} props.destinationIfsc - destination ifsc code
 * @returns {JSX.Element}
 */
const AccountNumberWithBank = ({
  sourceAccNo,
  destinationAccNo,
  sourceIfsc,
  destinationIfsc,
}) => {
  return (
    <div className="flex flex-col gap-y-gap-sm">
      <div className="flex items-center justify-between px-padding-sm gap-x-gap-sm">
        <p className={`text-font-sm text-text-primary  font-normal `}>
          {standardAccountNumberFormat(sourceAccNo)}
        </p>
        <SVGComponent
          url={"https://q2pay.in/new_assets/common/arrows/arrow_right_grey.svg"}
          color={"var(--text-secondary)"}
          height={"var(--icon-xs)"}
          width={"var(--icon-xs)"}
        />
        <p className={`text-font-sm text-text-primary  font-normal `}>
          {standardAccountNumberFormat(destinationAccNo)}
        </p>
      </div>
      <div className="w-full flex justify-between items-center ">
        <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-r-border-radius-sm py-padding-xs px-padding-sm">
          <div className="w-banklogo-width-sm h-icon-xs flex-shrink-0">
            <IfscCodeMapper ifscCode={sourceIfsc} />
          </div>
        </div>
        <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-l-border-radius-sm py-padding-xs px-padding-sm">
          <div className="w-banklogo-width-sm h-icon-xs flex-shrink-0">
            <IfscCodeMapper ifscCode={destinationIfsc} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountNumberWithBank;
